// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"51e7edc9","460":"bf3f3faa","917":"93a76b9a","954":"71984ce7"}[chunkId] + ".chunk.js";
};